import { DataModel } from '../models/dto/data-model.js';
import { LocalizedString } from '../models/serializable/localized-string.js';
import { IDataWithLocalizedDescription, IDataWithLocalizedTitle } from './localized-data.js';

export enum FormInputFieldStatus {
  Live = 'LIVE',
  Archived = 'ARCHIVED',
}

export abstract class FormInputField extends DataModel
  implements IDataWithLocalizedTitle, IDataWithLocalizedDescription {
  abstract get uniqueId(): string;
  abstract get titles(): LocalizedString;
  abstract get descriptions(): LocalizedString;
  abstract get isRequired(): boolean;
  abstract get status(): FormInputFieldStatus;

  get isArchived(): boolean {
    return this.status === FormInputFieldStatus.Archived;
  }
}
